import u from './help/util'

TXT['userStatus'] = false;
TXT['userStatusCallbacks'] = [];

export const registerUserStatusListener = (callback)=>{
    if (TXT['userStatus']){
        callback();
    } else {
        TXT['userStatusCallbacks'].push(callback)
    }
};

export async function loadUserStatus (){
    try {
        const response = await fetch(`${TXT.web_root}/${TXT.language}/user/user_status`);
        if (response.ok) {
            const txt = await response.text();
            u.q('#user_status_placeholder')[0].outerHTML = txt
            let el_user_status = u.q('#user_status_q');
            let user_id = 0;
            if (el_user_status.length){
                // user is logged in
                user_id = el_user_status[0].dataset.uid;
                TXT['userStatus'] = true; 
            }else{
                // user is not logged in
                TXT['userStatus'] = false; 
            }
            TXT['userStatusCallbacks'].forEach((f)=>{f(TXT['userStatus'], user_id)});
        }
    } catch(err) {
        console.log('Fetch error:' + err);
    } finally {
        u.q('.user-status-container')[0].classList.remove('opacity-0')
        u.clickHandlers({
            "logoutButton" : function(e){
                let logoutMessage="Are you sure you want to log out?"
                if (confirm(logoutMessage)){
                    window.location = this.href;
                }
            }
        });
    }
}; 


export const editButtons = (current_uid) => {
    const cur_uid = parseFloat(current_uid)
    if (!current_uid) return;

    u.q('article').forEach((el)=>{
        if ("users" in el.dataset){
            const article_users = el.dataset.users.split(',');
            for (const uid of article_users){
                if (cur_uid == parseFloat(uid)){
                    el.classList.add('edit_this')
                }
                u.clickHandlers({
                    "edit_this":(e)=>{
                        let item_id = 0;
                        if (e.target.classList.contains('clck-listening')){
                            item_id = e.target.dataset.id;
                        } else {
                            item_id = e.target.parentElement.dataset.id;
                        }
                        if (item_id){
                            const url = `${TXT.web_root}/${TXT.language}/itemform/edit/${item_id}`;
                            window.location = url
                        }else{
                            alert('no item id')
                        }
                    }
                },el)
            }
        }
    })
};
